import Alpine from 'alpinejs';
import "../store/email-capture"

(window as typeof window & { Alpine: typeof Alpine }).Alpine = Alpine;

const round = (n: number, p = 2) => Math.round(n * Math.pow(10, p)) / Math.pow(10, p);
const lbToKg = (lb: number) => lb / 2.20462;
const kgToLb = (kg: number) => kg * 2.20462;

document.addEventListener('alpine:init', () => {
  Alpine.data('toltrazurilDosageChartPage', function () {
    return {
      // Controls
      unit: 'lb',              // 'lb' | 'kg'
      ageGroup: 'puppy',       // 'puppy' | 'adult'
      purpose: 'treatment',    // 'treatment' | 'prevention'
      concentration: 2.5,        // % (2.5, 5, 7.5) or custom
      concCustomOpen: false,
      customConc: 5,

      // Lookup
      lookupWeight: null as number | null,
      lookupResult: null as null | { w: number; mg: string; mL: string; mgPerMl: number },

      // Data
      rows: [] as Array<{ w: number; mg: string; mL: string; note?: string }>,
      cards: [] as Array<{ w: number; mL: string }>,

      init() {
        // initial build
        this.rebuild();
      },

      toggleConcCustom() {
        this.concCustomOpen = !this.concCustomOpen;
      },
      applyCustomConc() {
        if (this.customConc && this.customConc > 0) {
          this.concentration = this.customConc;
          this.rebuild();
        }
      },

      mgPerMl() {
        // % → mg/mL
        return round((this.concentration / 100) * 1000, 0);
      },

      dosagePerLb() {
        if (this.ageGroup === 'puppy') return this.purpose === 'treatment' ? 15 : 5;
        return this.purpose === 'treatment' ? 20 : 10;
      },

      computeDose(weightInUnit: number) {
        // Convert to lb if needed
        const lb = this.unit === 'kg' ? kgToLb(weightInUnit) : weightInUnit;
        const mg = lb * this.dosagePerLb();
        const mL = mg / this.mgPerMl();
        return { mg: round(mg, 0), mL: round(mL, 2) };
      },

      computeLookup() {
        if (!this.lookupWeight || this.lookupWeight <= 0) { this.lookupResult = null; return; }
        const d = this.computeDose(this.lookupWeight);
        this.lookupResult = { w: this.lookupWeight, mg: d.mg.toFixed(0), mL: d.mL.toFixed(2), mgPerMl: this.mgPerMl() };

        // trigger email prompt after first successful lookup
        this.$store?.emailCap?.onResult?.();
      },

      buildWeights() {
        // sensible default ranges for dogs
        if (this.unit === 'lb') {
          return Array.from({ length: 26 }, (_, i) => 5 + i * 5); // 5..130 lb step 5
        } else {
          return Array.from({ length: 26 }, (_, i) => round(2 + i * 1, 1)); // 2..27 kg step 1
        }
      },

      rebuild() {
        const weights = this.buildWeights();
        const mgPerMl = this.mgPerMl();

        this.rows = weights.map(w => {
          const d = this.computeDose(w);
          const note = (this.unit === 'kg' && (w % 5 === 0)) ? 'Round if needed' : '';
          return { w, mg: d.mg.toFixed(0), mL: d.mL.toFixed(2), note };
        });

        // at-a-glance cards: pick a subset that looks great
        const pick = this.unit === 'lb' ? [5,10,15,20,25,30,40,50,60,75,90,100] : [2,3,4,5,7,10,12,15,18,20,24,27];
        this.cards = pick.map(w => {
          const d = this.computeDose(w);
          return { w, mL: d.mL.toFixed(2) };
        });
      },

      quickHeadline() {
        const who = this.ageGroup === 'puppy' ? 'puppy' : 'adult dog';
        const why = this.purpose === 'treatment' ? 'treatment' : 'prevention';
        return `${this.lookupWeight} ${this.unit} • ${who} • ${why}`;
      },

      printTable() {
        window.print();
      },

      downloadCSV() {
        const header = ['weight_' + this.unit, 'dose_mg', 'volume_ml@' + this.mgPerMl() + 'mg_per_ml'];
        const lines = [header.join(',')].concat(
          this.rows.map(r => [r.w, r.mg, r.mL].join(','))
        );
        const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `toltrazuril-dosage-chart-${this.unit}-${this.concentration}pct.csv`;
        a.click();
        URL.revokeObjectURL(url);
      }
    };
  });
});

Alpine.start();

